// stores/GlobalStore.ts
import { computed, observable, action } from 'mobx';
import { autobind } from 'core-decorators';
import { PAGE_STAGE } from '@src/constants/business';
import ZtServiceFactory from '@src/services/zt';
import BGMStore from '@src/business-components/bgm/store';

class NormalStageLogin {
  constructor(props) {
    this.context = props.$main;
  }

  $ztService = ZtServiceFactory.getDefaultInstance();

  /** 更新当前登录账号信息 */
  setAccountInfo = () => {
    // 默认预约不需要更新预约登录态
  };

  /**退出登录 */
  // @autobind
  exitAccount = () => {
    // 默认预约没有预约登录态
  };
}

class AppointmentStageLogin {
  constructor(props) {
    this.context = props.$main;
  }

  $ztService = ZtServiceFactory.getDefaultInstance();

  /** 更新当前登录账号信息 */
  setAccountInfo = phone => {
    if (phone) {
      // 将手机号码处理成前3位和后4位保留,中间用*号代替
      const maskedPhone = phone.replace(/(\d{3})\d{4}(\d{3})/, '$1***$2');

      // 预约帐号为手机号
      this.context.accountInfo = maskedPhone;
    }
  };

  /**退出登录 */
  // @autobind
  exitAccount = async () => {
    try {
      await this.$ztService.logout();
      this.context.accountInfo = null;
    } catch (error) {
      console.log('error', error);
    }
  };
}

class DownloadStageLogin {
  constructor(props) {
    this.context = props.$main;
  }

  $ztService = ZtServiceFactory.getDefaultInstance();

  /** 更新当前登录账号信息 */
  setAccountInfo = (accountInfo = window?.XPASS?.u_account) => {
    this.context.accountInfo = accountInfo;
  };

  /**退出登录 */
  @autobind
  async exitAccount() {
    try {
      await this.$ztService.logout();
      this.context.accountInfo = null;
    } catch (error) {
      console.log('error', error);
    }
  }
}

class GlobalStore {
  // 背景音乐
  @observable
  bgm = new BGMStore({
    audioSrc: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749451035221_UPGRADE(D)_48k24b.mp3',
    musicIconRotate: false
  });

  // 最近一次背景音乐的播放状态
  @observable lastBgmState = false;

  /**顶栏是否吸顶 */
  @observable navbarStick = false;

  // 是否预约阶段
  @observable inAppointmentTime = -1;

  // 是否下载阶段
  @observable inDownloadTime = 1;

  /**帐户信息 */
  @observable accountInfo = null;

  /**预约阶段开放福利码 */
  @observable isInSubscribeCodeTime = -1;

  /**下载阶段开放福利码 */
  @observable downLoadGetCodeStatus = -1;

  @observable appointmentCount = void 0;

  // 顶栏是否展示下载按钮
  @observable showNavbarDownloadBtn = true;

  /**预约阶段登录 */
  AppointmentStageLogin = new AppointmentStageLogin({ $main: this });

  /**下载阶段登录 */
  DownloadStageLogin = new DownloadStageLogin({ $main: this });

  /**下载阶段登录 */
  NormalStageLogin = new NormalStageLogin({ $main: this });

  /**是否为下载阶段 */
  @computed
  get isDownloadStage() {
    return this.inDownloadTime === PAGE_STAGE.download.isOpen;
  }

  /**是否为预约阶段 */
  @computed
  get isAppointmentStage() {
    return !this.isDownloadStage;
  }

  /**是否为默认阶段（只有预约的阶段，没有礼包领取） */
  @computed
  get isNormalStage() {
    return this.isAppointmentStage && +this.isInSubscribeCodeTime === 0;
  }

  @computed
  get authServise() {
    if (this.isNormalStage) {
      return this.NormalStageLogin;
    }
    if (this.isAppointmentStage) {
      return this.AppointmentStageLogin;
    }
    if (this.isDownloadStage) {
      return this.DownloadStageLogin;
    }
  }

  /**
   * 更改顶栏吸顶状态
   * @param {boolean} state 是否吸顶
   */
  @action
  toggleNavBarStickState(state) {
    this.navbarStick = state;
  }

  /**
   * 更改背景音乐状态
   * @param {boolean} state 是否播放
   */
  toggleBgmState(state) {
    this.bgm.handleChange(state);
  }

  /**
   * 记录背景音乐最近一次的播放状态
   */
  recordLastBgmState() {
    this.lastBgmState = this.bgm.isPlaying;
  }
}

// 创建全局 Store 实例（单例模式）
const globalStore = new GlobalStore();

export default globalStore;
